function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("title", null, "A9308264-E973-4FCB-BD92-EA1FED2274CD");
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Lodge-enquiry",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lodge-enq-lodged-open-MD",
  transform: "translate(-660.000000, -238.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(640.000000, 224.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ui/icon/utility/24/gov-circle",
  transform: "translate(20.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle",
  stroke: "#9E9E9E",
  cx: 12,
  cy: 12,
  r: 11.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9E9E9E",
  x: 9,
  y: 11,
  width: 1,
  height: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9E9E9E",
  x: 14,
  y: 11,
  width: 1,
  height: 6
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-6",
  stroke: "#9E9E9E",
  strokeLinejoin: "round",
  points: "19 11 5 11 5 9 12 7 19 9"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 17,
  x2: 19,
  y2: 17,
  id: "Line-28",
  stroke: "#9E9E9E",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#9E9E9E",
  strokeLinejoin: "round",
  x: 6,
  y: 11,
  width: 12,
  height: 6
})))));
const SvgUiIconUtility24GovCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility24GovCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-24-gov-circle.dbfd58de.svg";
export { ForwardRef as ReactComponent };